<template>
    <nav class="links-wrapper">
        <div class="router-wrapper">
            <router-link class="router-link" :to="`/${$i18n.locale}/`">{{ $t('nav.home') }}</router-link>
            <router-link class="router-link" :to="`/${$i18n.locale}/painting`">{{ $t('nav.painting') }}</router-link>
            <router-link class="router-link" :to="`/${$i18n.locale}/scaffolding`">{{ $t('nav.scaffolding') }}</router-link>
            <router-link class="router-link" :to="`/${$i18n.locale}/welding`">{{ $t('nav.mechanics') }}</router-link>
            <router-link class="router-link" :to="`/${$i18n.locale}/about`">{{ $t('nav.about') }}</router-link>
            <router-link class="router-link" :to="`/${$i18n.locale}/contact`">{{ $t('nav.contact') }}</router-link>
        </div>
        <span>
            <select v-model="$i18n.locale">
                <option @click.prevent="setLocale('pl')" value="pl">🇵🇱 Polski</option>
                <option @click.prevent="setLocale('en')" value="en">🇬🇧 English</option>
                <option @click.prevent="setLocale('no')" value="no">🇳🇴 Norsk</option>
            </select>
        </span>
    </nav>
</template>

<script>
export default {
    name: 'header-links',
    methods: {
        setLocale(locale) {
            this.$i18n.locale = locale;
            this.$router.push({
                params: { lang: locale }
            })
        },
    },
}
</script>

<style lang="scss">
@mixin mobile {
    @media only screen and (max-width: 700px) {
        @content;
    }
}

@mixin mobileBig {
    @media only screen and (max-width: 1400px) {
        @content;
    }
}
.router-wrapper {
    @include mobile {
        margin: 0 0 0 50px;
    }
    .router-link {
        @include mobile {
            min-width: 150px;
        }
    }
}
</style>